var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYouTube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8993 24.3499C45.5576 23.0743 44.5328 22.0672 43.2346 21.7148C40.8945 21.0938 31.5 21.0938 31.5 21.0938C31.5 21.0938 22.1055 21.0938 19.7483 21.7148C18.4501 22.0505 17.4424 23.0575 17.0837 24.3499C16.4688 26.6661 16.4688 31.5 16.4688 31.5C16.4688 31.5 16.4688 36.3339 17.1007 38.6501C17.4424 39.9257 18.4672 40.9328 19.7654 41.2852C22.1055 41.9063 31.5 41.9063 31.5 41.9063C31.5 41.9063 40.8945 41.9063 43.2517 41.2852C44.5499 40.9495 45.5576 39.9425 45.9163 38.6501C46.5312 36.3339 46.5312 31.5 46.5312 31.5C46.5312 31.5 46.5313 26.6661 45.8993 24.3499ZM28.4254 35.8975V27.1025L36.2827 31.5L28.4254 35.8975Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYouTube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/YouTube.5bd693ac.svg";
export { ForwardRef as ReactComponent };